import ISvgProps from '../SvgLoader/ISvgProps';
import { FC } from 'react';

export const CloseCheckImageIcon: FC<ISvgProps> = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="46" viewBox="0 0 40 46" fill="none">
			<g filter="url(#filter0_dd_298_32776)">
				<ellipse cx="20" cy="19.7301" rx="14" ry="13.7301" fill="white" />
			</g>
			<path
				d="M30 20C30 25.523 25.523 30 20 30C14.477 30 10 25.523 10 20C10 14.477 14.477 10 20 10C25.523 10 30 14.477 30 20ZM28 20C28 17.8783 27.1571 15.8434 25.6569 14.3431C24.1566 12.8429 22.1217 12 20 12C17.8783 12 15.8434 12.8429 14.3431 14.3431C12.8429 15.8434 12 17.8783 12 20C12 22.1217 12.8429 24.1566 14.3431 25.6569C15.8434 27.1571 17.8783 28 20 28C22.1217 28 24.1566 27.1571 25.6569 25.6569C27.1571 24.1566 28 22.1217 28 20ZM18.586 20L15.757 17.172L17.172 15.757L20 18.586L22.828 15.757L24.243 17.172L21.414 20L24.243 22.828L22.828 24.243L20 21.414L17.172 24.243L15.757 22.828L18.586 20Z"
				fill="#5977EB"
			/>
			<defs>
				<filter
					id="filter0_dd_298_32776"
					x="0"
					y="0"
					width="40"
					height="45.46"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB">
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="6" />
					<feGaussianBlur stdDeviation="3" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0577961 0 0 0 0 0.0804438 0 0 0 0 0.185189 0 0 0 0.1 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_298_32776" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="3" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0577961 0 0 0 0 0.0804438 0 0 0 0 0.185189 0 0 0 0.12 0"
					/>
					<feBlend mode="normal" in2="effect1_dropShadow_298_32776" result="effect2_dropShadow_298_32776" />
					<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_298_32776" result="shape" />
				</filter>
			</defs>
		</svg>
	);
};
